import { z } from "zod";
import { nookSummarySchema } from "./nook.js";
/**
 * `POST /v1/search` — the search bar's live dropdown (block 16). Keyword and
 * tag matching only; no LLM, no plan gate.
 */
export const searchRequestSchema = z.object({
    query: z.string().trim().min(1).max(200),
    limit: z.number().int().min(1).max(20).default(8),
});
/**
 * Wrap each matched term inside `snippet`. Control characters, so no nook text
 * can forge a highlight and no HTML ever crosses the wire.
 */
export const SNIPPET_START = "\u0002";
export const SNIPPET_END = "\u0003";
/** A card plus the matched passage. `null` for a tag-only match. */
export const searchResultSchema = nookSummarySchema.extend({
    snippet: z.string().nullable(),
});
/**
 * One SSE frame. `vector` is reserved so semantic results can stream in later
 * with no client change (plan §6.5).
 */
export const searchEventSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("results"),
        source: z.enum(["keyword", "vector"]),
        nooks: z.array(searchResultSchema),
    }),
    z.object({ type: z.literal("done") }),
]);
//# sourceMappingURL=search.js.map